import {Link, useLocation} from "react-router-dom";
import {Box, Button, Typography} from "@mui/material";
import {fontType} from "../../../constants/font";
import iconWarning from "../../../assets/badge-warning.png";
import icon from "../../../assets/skolenie_ikona_blue.svg";
import React from "react";

function PromoPopUpV2({setShowPromoPopUp}) {
    const shadowStyle = "0px 2px 4px rgba(0, 0, 0, 0.1)";
    const location = useLocation();

    const isActive = (pathname) => {
        return location.pathname === pathname;
    };

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    function renderActionButton() {
        return (
            <Button
                component="a"
                sx={{
                    borderRadius: "28px",
                    border: "2px solid",
                    my: "10px",
                    borderColor: "#7b7cd5",
                    fontFamily: fontType.regular,
                    fontSize:  16,
                    cursor: "pointer",
                    color: "#1d1a56",
                    height: "44px",
                    width: "186px",
                    textTransform: "initial",
                    "&:hover": {
                        backgroundColor: "#7b7cd5",
                        color: "white",
                    },
                }}
            >
                Detaily
            </Button>
        )
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "279px",
                position: "relative"
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '5px',
                    right: '5px'
                }}
            >
                <img
                    onClick={() => setShowPromoPopUp(false)}
                    style={{ cursor: "pointer", rotate: "45deg" }}
                    src={require("../../../assets/red_plus.png")}
                    alt="arrow_close"
                />
            </Box>
            <Box
                sx={{
                    backgroundColor: "white",
                    borderRadius: "20px",
                    boxShadow: shadowStyle,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "column",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        flexDirection: "column",
                    }}
                >
                    <Box
                        sx={{
                            width: "77px",
                            height: "77px",
                            marginTop: "10px",
                            display: "flex",
                            position: "relative",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                    >
                        <img
                            src={iconWarning}
                            alt="new"
                            style={{
                                position: "absolute",
                                height: "80px",
                                zIndex: 10,
                                top: -30,
                                right: 90,
                            }}
                        />
                        <img
                            src={icon}
                            alt="student_hat"
                            style={{
                                position: "absolute",
                                height: "130px",
                                marginBottom: "15px",
                            }}
                        />
                    </Box>
                    <Typography
                        sx={{
                            fontFamily: fontType.medium,
                            fontSize: 19,
                            marginTop: "10px",
                            color: "#7b7cd5",
                            textAlign: "center",
                            marginRight: "15px",
                            marginLeft: "15px",
                            lineHeight: "26px",
                        }}
                    >
                        <div
                            style={{
                                fontFamily: fontType.bold,
                                fontSize: 22,
                            }}
                        >
                            Preplácanie školení!
                        </div>
                        Preplatenie kurzov cez programy ÚP <span style={{fontFamily: fontType.bold}}>obnovené</span> od 16.3.2026
                    </Typography>
                </Box>
                <Box>
                    {isActive("/skolenia") ? (
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                justifyContent: "start",
                            }}
                            onClick={() => {
                                scrollToSection("kompas");
                                setShowPromoPopUp(false);
                            }}
                        >
                            { renderActionButton() }
                        </Box>
                    ) : (
                        <Link to="/skolenia#kompas" style={{ textDecoration: "none" }}>
                            { renderActionButton() }
                        </Link>
                    )}

                </Box>
            </Box>
        </Box>
    )
}

export default PromoPopUpV2;